export const ENPOINT =
{
  urlBase: '/',
  url: '/api-clientes/',
  len: 'ES'
};



   


// WEBPACK FOOTER //
// ./src/app/services/endpoint.ts